import axios from 'axios';

import {URL_BASE_API} from '../configs/urlConfigs';
import {userGroupUrlCheck} from '../utils/userGroupUrlCheck';

let userGroupRefreshToken = '';

export const refreshTokenService = (request) => {
  const REFRESH_ENDPOINT = URL_BASE_API+'token-refresh/';
  
  let userGroupData = userGroupUrlCheck(window.location);
  userGroupRefreshToken    = userGroupData.accessToken;

  const parameters = {
    url: REFRESH_ENDPOINT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: userGroupRefreshToken
  };

  return axios(parameters)
  .then(response => {
      console.log(response);
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };    
    return errorResp;
  }); 
};


// export const refreshTokenService = (request) => {
//   const LOGOUT_ENDPOINT = URL_BASE_API+'logout/';
//   const parameters = {
//     url: LOGOUT_ENDPOINT,
//     method: 'POST',
//     headers:{
//       'Content-Type': 'application/json',
//       'unid':request.data.unid
//     },
//     data: request.data
//   };

//   return axios(parameters)
//     .then(response => {   
//       return response;
//   }).catch(error=>{
//     let errorResp = {      
//       status: error.response.status,
//       statusText: error.response.statusText
//     };
//     return errorResp; 
//   }); 
// };